import { render, staticRenderFns } from "./clientesPorProduto.vue?vue&type=template&id=7de50568&scoped=true&"
import script from "./clientesPorProduto.vue?vue&type=script&lang=js&"
export * from "./clientesPorProduto.vue?vue&type=script&lang=js&"
import style0 from "./clientesPorProduto.vue?vue&type=style&index=0&id=7de50568&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de50568",
  null
  
)

export default component.exports